export enum SettingIds {
  setting_MaxUlsHeartbeatTime = "BootstrapperMaxUlsHeartbeatTime",
  setting_NoCompleteWarning1Time = "BootstrapperNoCompleteWarning1Time",
  setting_NoCompleteWarning2Time = "BootstrapperNoCompleteWarning2Time",
  setting_NoCompleteWarning3Time = "BootstrapperNoCompleteWarning3Time",
  setting_RemoteUlsETag = "RemoteUlsETag",
  setting_RemoteUlsSuppressions = "RemoteUlsSuppressions",
  setting_SettingsFetchPeriod = "BootstrapperSettingsFetchPeriod",
  setting_Timestamp = "timestamp",
  setting_UlsHeartbeatIntervalMs = "BootstrapperUlsHeartbeatIntervalMs",
  setting_UlsHeartBeatIsEnabled = "BootstrapperUlsHeartBeatIsEnabled",
  setting_UlsUploadCadenceMs = "BootstrapperUlsUploadCadenceMs",
  setting_WordConsumptionViewToEditRedirectIsEnabled = "WordConsumptionViewToEditRedirectIsEnabled",
  setting_RequestedCallThrottlingDefaultToViewMinimumValue = "RequestedCallThrottlingDefaultToViewMinimumValue",
  setting_BulsEndpointUrl = "BulsEndpointUrl",
  setting_EnableCommonHostDiagnosticsParams = "EnableCommonHostDiagnosticsParams",
  setting_EnableTwoStepBootForWordForEmptyWopisrc = "EnableICNForWord",
  setting_EnableModernEmbedViewForPowerPoint = "EnableModernEmbedViewForPowerPoint",
  setting_EnableModernEmbedViewInOneUpForPowerPoint = "EnableModernEmbedViewInOneUpForPowerPoint",
  setting_EnableModernEmbedViewForPowerPointGlobalAppUrl = "EnableModernEmbedViewForPowerPointGlobalAppUrl",
  setting_EnableModernReadingViewForPowerPoint = "EnableModernReadingViewForPowerPoint",
  setting_EnableDefaultToModernForPowerPoint = "EnableDefaultToModernForPowerPoint",
  setting_ShouldLogJsApiKpisForWord = "ShouldLogJsApiKpisForWord",
  setting_WordSwitchToViewInTeamsJsapiV1Enabled = "WordSwitchToViewInTeamsJsapiV1Enabled",
  setting_EnableWordSessionRefreshTelemetry = "EnableWordSessionRefreshTelemetry",
  setting_PowerPointUseEssDCHint = "PowerPointUseEssDCHint",
  setting_ModernEmbedViewBootstrapperFeatureGatesForPowerPoint = "ModernEmbedViewBootstrapperFeatureGatesForPowerPoint",
  setting_ModernReadingViewBootstrapperFeatureGatesForPowerPoint = "ModernReadingViewBootstrapperFeatureGatesForPowerPoint",
  setting_ModernEmbedViewForPowerPointEnabledPercentage = "ModernEmbedViewForPowerPointEnabledPercentage",
  setting_PowerPointESSCookieLookbackThresholdHour = "PowerPointESSCookieLookbackThresholdHour",
  setting_PowerPointSetESSCookieLookbackExpEnabled = "PowerPointSetESSCookieLookbackExpEnabled",
  setting_ExcelForceViewOnlyInTeamsJsapiV1 = "ExcelForceViewOnlyInTeamsJsapiV1",
  setting_EnableWordSessionRefreshLoggingCleanup = "EnableWordSessionRefreshLoggingCleanup",
  setting_WordRefreshTelemetryExpirationInDays = "WordRefreshTelemetryExpirationInDays",
}
